import { Paper } from "@material-ui/core";
import styled from 'styled-components';

export const CardInfo = styled(Paper)`
  padding: 16px;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const SectionTitle = styled.h2`
  font-family: 'Roboto', sans-serif;
  font-size: 16px;
  font-weight: 600;
  margin: 0;
  color: #031795;
`;

export const AddNewRelationContainer = styled.div`
  margin-top: 16px;
  margin-bottom: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;  
  flex: 1;
  width: 100%;
`;

export const SelectContainer = styled.div`
  width: 100%;
`;
